module.exports = __webpack_public_path__ + "static/media/product1.629c7883.jpg";